const convertHertz = function (HZ) {
  return (150940 - HZ * 19.74) / (HZ * 2.8875 - 137.5);
};
const convertValueByParam = function (param, value) {
  if (param === 'WV') {
    return value;
  }
  if (typeof value !== 'undefined') {
    value = parseFloat(value);
    if (param === 'PRES') {
      return value / 100;
    }
    if (param === 'SOIL_C' || param === 'SOIL_B' || param === 'SOIL_D' || param === 'SOIL_E') {
      return convertHertz(value);
    }
    if (param === 'HUM') {
      return value < 8 ? 8 : value;
    }
    return value;
  }
  return value;
};

const hardwareVersionToName = (hardwareVersion, deviceType, tags) => {
  switch (hardwareVersion) {
    case 1:
      return 'Libelium (Depricated)';
    case 2:
      return '2.0 (Depricated)';
    case 3:
      if (deviceType === 'GSM_NODE4' && tags && tags.indexOf('3.0-f4') !== -1) {
        return '3.0 - F4';
      }
      if (deviceType !== 'GSM_NODE4') {
        return '3.0 - F4';
      }
      return '3.0 - F5';
    case 4:
      return '4.0 - Kranti';
    case 5:
      return '5.0 - Nova';
    case 6:
      return '6.0 - Cellular Fasal One';
    case 7:
      return '7.0 - WAN Fasal One';
    default:
      return hardwareVersion;
  }
};
export {convertValueByParam, hardwareVersionToName};
